import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form as ImportForm } from 'semantic-ui-react';
import excludeKeys from '../../../../../utils/excludeKeys';

class Form extends Component {
  render() {
    return (
      <ImportForm {...excludeKeys(this.props)}>
        { this.props.children }
      </ImportForm>
    );
  }
}

export default Form;

Form.propTypes = {
  children: PropTypes.node,
};
